module.exports = __webpack_public_path__ + "assets/TriangleByMidpoints.f8f9973b0822b10d1c996b7645848b67.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/TriangleByMidpoints.gmt
// module id = 1028
// module chunks = 0